import http_request from './http_request'
import config from 'config'

function getFilters() {
	return http_request.post(config.services + 'service.php')
		.send({
			method: 'getFiltersNew',
		})
}

function getStandardsCategories(entityUID) {
	return http_request.post(config.services + 'filters/getStandard.php')
		.send({
			entityUID,
		})
}

function getStandardByStrand(entityUID) {
	return http_request.post(config.services + 'filters/getStandardByStrand.php')
		.send({
			entityUID,
		})
}

function getCatalog() {
	return http_request.post(config.services + 'service.php')
		.send({
			method: 'getCatalogAllFeatured',
		})
}

function getSearchResults(query, entityUID, page, lessonType) {
	const sendParams = {
		method: 'searchTheStore',
		page,
		search: query,
		lessonType,
	}

	if (entityUID && entityUID.length) sendParams.entityUID = entityUID

	return http_request.post(config.services + 'service.php').send(sendParams)
}

function getStoreFolderResults(entityUID, page) {
	const sendParams = {
		method: 'getTheStore',
		entityUID,
		page,
	}

	return http_request.post(config.services + 'service.php').send(sendParams)
}

// code repeated on my_library_sync and private_library_sync
function launchSession(presentation_uid, isNew, jwt, sessionType) {
	const headers = {}
	if (jwt) {
		headers.jwt = jwt
	}

	return http_request.post(config.hub + 'session/start')
		.withHeaders(headers)
		.send({
			device_type: 'ipad',
			presentation_uid,
			device_uid: 'tabc',
			session_uid: '',
			new: isNew,
			session_type: sessionType,
		})
}

function duplicateActivity(jwt, currentSlideId, entityUID, lessonType) {
	const headers = {}
	if (jwt) {
		headers.jwt = jwt
	}

	return http_request.post(`${config.api}slide/${currentSlideId}/copy_by_presentation`)
		.withHeaders(headers)
		.send({
			entityUID,
			lessonType,
		})
}

function duplicateCustomActivity(jwt, currentSlideId, entityUID, lessonType) {
	const headers = {}
	if (jwt) {
		headers.jwt = jwt
	}

	return http_request.post(`${config.api}custom_slides/${currentSlideId}/copy_by_presentation`)
		.withHeaders(headers)
		.send({
			entityUID,
			lessonType,
		})
}

export default {
	getFilters,
	getStandardsCategories,
	getStandardByStrand,
	getCatalog,
	getSearchResults,
	getStoreFolderResults,
	launchSession,
	duplicateActivity,
	duplicateCustomActivity,
}
